import { AUDIO_NODE_HEIGHT, AUDIO_NODE_WIDTH } from "../Constants";
import { NodeStore, StoreType } from "./NodeStore";

/**
 * This class represents an audio node that plays an audio file from a given URL.
 * It extends the NodeStore class by adding properties specific to audio nodes 
 * while also reusing shared behavior such as positioning and sizing.
 */
export interface AudioNodeArgs {
    x: number;
    y: number;
    url: string;
    width?: number;
    height?: number;
}

/**
 * This method is the constructor for an AudioNodeStore and initializes its 
 * positioning and audio source. It sets default dimensions if none are provided.
 * @param args The Object containing the x and y coordinates, audio URL, and optional width and height.
 */
export class AudioNodeStore extends NodeStore {
    public url: string;
    public title: string = "";

    constructor(args: AudioNodeArgs) {
        super();
        this.type = StoreType.Audio;
        this.x = args.x;
        this.y = args.y;
        this.url = args.url;
        this.width = args.width ?? AUDIO_NODE_WIDTH;
        this.height = args.height ?? AUDIO_NODE_HEIGHT;
    }
}